<template>
  <div>
    <v-layout wrap justify-space-around row pa-2 v-if="count">
      <div>
        <v-card class="ma-2" width="300">
          <router-link :to="{ name: 'actors.list' }">
            <v-card-text class="fill-height text-md-center">
              <v-icon size="40" color="primary">mdi-account-group-outline</v-icon><br />
              <h3>{{ count.actor_count }}</h3>
              <h3 class="text-uppercase">Acteurs enregistrés</h3>
            </v-card-text>
          </router-link>
        </v-card>
      </div>
      <div>
        <router-link :to="{ name: 'actors.cards' }">
          <v-card class="ma-2" width="300">
            <v-card-text class="fill-height text-md-center">
              <v-icon size="40" color="primary">mdi-account-card-details-outline</v-icon><br />
              <h3>{{ count.card_count }}</h3>
              <h3 class="text-uppercase primary--text">
                <router-link :to="{ name: 'actors.cards' }">Cartes générées</router-link>
              </h3>
            </v-card-text>
          </v-card>
        </router-link>

      </div>
      <div>
        <v-card class="ma-2" width="300">
          <router-link :to="{ name: 'events.past' }"><v-card-text class="fill-height text-md-center">
              <v-icon size="40" color="primary">mdi-calendar-month-outline</v-icon><br />
              <h3>{{ count.event_count }}</h3>
              <h3 class="text-uppercase primary--text">Evènements organisés</h3>
            </v-card-text>
          </router-link>
        </v-card>
      </div>
    </v-layout>
    <!-- <v-layout row wrap v-if="Object.keys(voiceMailStatistic).length !== 0">
      <v-flex xs12 sm6 md3>
        <div class="dash-message mb-3">
          <span>{{ new Date().getFullYear() }}</span>
          <v-select
            :items="months"
            v-model="selectedPeriod"
            item-text="name"
            return-object
            hide-details
            label="2019"
            solo
            dense
          ></v-select>
          <div class="message-body mt-2 fill-height text-lg-right">
            <v-layout row wrap>
              <v-flex xs12 sm2>
               
                 <v-icon style="opati" class="dash-color-success" size="50">mdi-microphone-outline</v-icon>
              </v-flex>
              <v-flex xs12 sm10>
                <span>{{
                  voiceMailStatistic
                  ? voiceMailStatistic.total_voice_count[selectedPeriod.id]
                  : 0
                }}</span>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <div class="dash-message mb-4">
          <div class="message-header">
            <span>Appels réussis</span>
            <div class="underliner-message border-success"></div>
          </div>
          <div class="message-body text-lg-right">
            <v-layout row wrap>
              <v-flex xs2 sm2 md2>
                <v-icon class="dash-color-success" size="45">mdi-microphone-outline</v-icon>
              </v-flex>
              <v-flex xs10 sm10 md10>
                <span>{{
                  voiceMailStatistic &&
                  voiceMailStatistic.voice_mail_received_count
                  ? voiceMailStatistic.voice_mail_received_count[
                  selectedPeriod.id
                  ]
                  : 0
                }}</span>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-flex>

      <v-flex xs12 sm6 md3>
        <div class="dash-message mb-3">
          <div class="message-header">
            <span>Appels manqués</span>
            <div class="underliner-message border-info"></div>
          </div>
          <div class="message-body text-lg-right">
            <v-layout row wrap>
              <v-flex xs2 sm2 md2>
                <v-icon color="dash-color-info" size="45">mdi-message-processing</v-icon>
              </v-flex>
              <v-flex xs10 sm10 md10>
                <span>{{
                  voiceMailStatistic
                  ? voiceMailStatistic.voice_mail_missed_count[
                  selectedPeriod.id
                  ]
                  : 0
                }}</span>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-flex>

      <v-flex xs12 sm6 md3>
        <div class="dash-message mb-3">
          <div class="message-header">
            <span>Appels Raccrochés</span>
            <div class="underliner-message border-error"></div>
          </div>
          <div class="message-body text-lg-right">
            <v-layout row wrap>
              <v-flex xs12 sm2>
                <v-icon color="primary" size="45">mdi-phone-return</v-icon>
              </v-flex>
              <v-flex xs12 sm10>
                <span>{{
                  voiceMailStatistic
                  ? voiceMailStatistic.voice_mail_rejected_audio_count[
                  selectedPeriod.id
                  ]
                  : 0
                }}</span>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-flex>
    </v-layout> -->

    <v-card class="mt-3">
      <v-card-title>
        <h6 class="primary--text">Participation par type d'évènement</h6>
        <v-spacer></v-spacer>
        <v-flex xs3 v-if="loaded_type">
          <v-btn color="primary" outlined small @click="exportType()">
            <v-icon class="mr-3">mdi-image-move</v-icon> Télécharger ce graphe
          </v-btn>
        </v-flex>
      </v-card-title>

      <v-card-text v-if="loaded_type">
        <div text-center>
          <stats-donut-type-chart ref="typedonutchart" :data="type_chart_data" :options="donut_chart_options">
          </stats-donut-type-chart>
        </div>
      </v-card-text>
    </v-card>

    <v-card class="mt-3">
      <v-card-title>
        <h6 class="primary--text">Participants par évènement et par sexe</h6>
        <v-spacer></v-spacer>
        <v-flex xs3 v-if="loaded_type_sexe">
          <v-btn color="primary" outlined small @click="exportTypeSexe()">
            <v-icon class="mr-3">mdi-image-move</v-icon> Télécharger ce graphe
          </v-btn>
        </v-flex>
      </v-card-title>
      <v-card-text v-if="loaded_type_sexe">
        <div text-center>
          <stats-bar-chart ref="typesexechart" :data="type_sexe_chart_data" :options="bar_chart_options">
          </stats-bar-chart>
        </div>
      </v-card-text>
    </v-card>

    <v-card class="mt-3">
      <v-card-title>
        <h6 class="primary--text">
          Participants par évènement et par domaine d'activité
        </h6>
        <v-spacer></v-spacer>
        <v-flex xs3 v-if="loaded_type_domaine">
          <v-btn color="primary" outlined small @click="exportTypeDomaine()">
            <v-icon class="mr-3">mdi-image-move</v-icon> Télécharger ce graphe
          </v-btn>
        </v-flex>
      </v-card-title>

      <v-card-text v-if="loaded_type_domaine">
        <div text-center>
          <stats-bar-chart ref="typedomainechart" :data="type_domaine_chart_data" :options="bar_chart_options">
          </stats-bar-chart>
        </div>
      </v-card-text>
    </v-card>

    <v-card class="mt-3">
      <v-card-title>
        <h6 class="primary--text">
          Tableau de synthèse : Participants par évènement et par domaine d'activité
        </h6>
        <v-spacer></v-spacer>
        <v-flex xs3> </v-flex>
      </v-card-title>
      <v-card-text class="overflow-auto">
        <table>
          <thead>
            <th></th>
            <th v-for="item in types" :key="item.id">
              {{
                item.name.length < 50 ? item.name : item.name.substring(0, 50) + " ..." }} </th>
            <th>Total</th>
          </thead>

          <tbody v-if="domaines && domaines.length > 0">
            <tr v-for="(domaine, i) in domaines">
              <td>{{ domaine.name }}</td>
              <td v-for="(item, index) in matrix_data[domaine.name]" :key="index">
                {{ item }}
              </td>
              <td class="ligneTotal">
                {{ domaine_total[domaine.name] }}
              </td>
            </tr>
            <tr>
              <td class="ligneTotal">Total</td>
              <td class="ligneTotal" v-for="(total, index) in type_total" :key="index">
                {{ total }}
              </td>
            </tr>
          </tbody>
        </table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import axios from 'axios'
import BarChart from '../../components/BarChart'
import Doughnut from '../../components/DoughnutChart'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import Permissions from '~/mixins/Permissions';

export default {
  name: 'overview',
  mixins: [Permissions],
  components: {
    'stats-bar-chart': BarChart,
    'stats-donut-type-chart': Doughnut,
    ChartDataLabels
  },

  data: () => ({
    loaded_type: false,
    loaded_type_sexe: false,
    loaded_type_domaine: false,
    real_matrix: [],

    tranche_sexe: ['Homme', 'Femme', 'Jeune'],
    selectedPeriod: 1,
    type_chart_data: {},
    type_sexe_chart_data: {},
    type_domaine_chart_data: {},

    months: [
      { id: 1, name: 'Janvier', end: 31 },
      { id: 2, name: 'Février', end: 28 },
      { id: 3, name: 'Mars', end: 31 },
      { id: 4, name: 'Avril', end: 30 },
      { id: 5, name: 'Mai', end: 31 },
      { id: 6, name: 'Juin', end: 30 },
      { id: 7, name: 'Juillet', end: 31 },
      { id: 8, name: 'Août', end: 31 },
      { id: 9, name: 'Septembre', end: 30 },
      { id: 10, name: 'Octobre', end: 31 },
      { id: 11, name: 'Novembre', end: 30 },
      { id: 12, name: 'Decembre', end: 31 }
    ],
    type_total: [],
    domaine_total: [],
    matrix_type_dom: [],
    matrix_dom_type: [],
    matrix_type_sexe: [],

    donut_chart_options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: true,
        labels: {
          fontColor: '#424242',
          padding: 20
        },
        position: 'bottom'
      },
      plugins: {
        datalabels: {
          color: '#FFFFFF',
          anchor: 'center',
          align: 'center',
          formatter: function (value) {
            return Math.round(value) + ' %'
          },
          font: {
            weight: 'bold',
            size: 14
          }
          /* display: function(context) {
              var index = context.dataIndex;
              var value = context.dataset.data[index]
              return value!=0;
            }*/
        }
      }
    },

    bar_chart_options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: true,
        labels: {
          fontColor: '#424242',
          padding: 30
        },
        position: 'bottom'
      },
      plugins: {
        datalabels: {
          // color: '#FFFFFF',
          anchor: 'end',
          align: 'center',
          formatter: Math.round,
          font: {
            weight: 'bold'
          }
          /* display: function(context) {
              var index = context.dataIndex;
              var value = context.dataset.data[index]
              return value !=0;
            }*/
        }
      }
    },
    nb_check: 0,
    nb_check_sexe: 0
  }),

  created() {
    this.$checkPermission('access dashboard')
    this.selectedPeriod = this.months[new Date().getMonth()]
    this.fetchUtils()
  },

  computed: {
    matrix_data() {
      const liste = this.$store.getters.getDataStats
      
      this.type_total = liste['tot_type']
      this.domaine_total = liste['tot_dom']
      this.matrix_type_dom = liste['matrix_type_dom']
      this.matrix_dom_type = liste['matrix_dom_type']
      this.matrix_type_sexe = liste['matrix_type_sexe']

      this.loadDonutChartType()
      this.loadChartTypeSexe()
      // this.loadChartTypeDomain()

      return liste['matrix_dom_type']
    },

    domaines() {
      return this.$store.getters.domains
    },
    count() {
      return this.$store.getters.getDataCount
    },
    types() {
      return this.$store.getters.event_types
    },
    tranche_types() {
      const liste_types = this.types
      const tableau_types = []
      liste_types.forEach(function (item) {
        const valeur = item.name.substring(0, 35)
        tableau_types.push(valeur)
      })
      return tableau_types
    },
    voiceMailStatistic() {
      return this.$store.getters.voiceMailStatistic
    }
  },

  watch: {
    selectedPeriod: {
      handler(newVal) {
        const currentDate = new Date()
        let month = newVal.id
        const monthEnd = newVal.end

        if (month < 10) month = '0' + month

        // this.$store.dispatch("loadVoiceMailStatistics", {
        //   period_start: currentDate.getFullYear() + "-" + month + "-01",
        //   period_end: currentDate.getFullYear() + "-" + month + "-" + monthEnd,
        // });
      }
    }
  },
  methods: {
    fetchUtils() {
      this.$store.dispatch('loadDataStats')
      this.$store.dispatch('loadDataCount')
      // this.$store.dispatch("loadVoiceMailStatistics", {
      //   period_start: "2019-08-20",
      //   period_end: "2019-08-27",
      // });
      this.$store.dispatch('fetchDomains')
      this.$store.dispatch('fetchEventTypes')
    },

    loadDonutChartType() {
      const tab_type = this.type_total
      // console.log(tab_type);
      if (tab_type != null) {
        const val = Object.values(tab_type)

        let somme = 0
        const tab_prct = []

        val.forEach(function (item) {
          somme = somme + item
        })

        val.forEach(function (item) {
          const resu = (item / somme) * 100
          tab_prct.push(resu)
        })

        const valeurs_type = [
          {
            backgroundColor: [
              '#e91e63',
              '#9c27b0',
              '#2196f3',
              '#4caf50',
              '#64dd17',
              '#ff9800',
              '#4dd0e1',
              '#880e4f',
              '#d500f9'
            ],
            data: tab_prct
          }
        ]

        const type_data = {}
        type_data.labels = this.tranche_types
        type_data.datasets = valeurs_type

        this.type_chart_data = type_data
        this.loaded_type = true
      }

      // console.log(this.loaded_type, this.type_chart_data);
    },

    loadChartTypeSexe() {
      // this.nb_check_sexe++;

      // if(this.nb_check_sexe >= 2){
      const tab_type = this.type_total ? Object.keys(this.type_total) : []
      const type_dom_data = this.matrix_type_sexe ? Object.values(this.matrix_type_sexe) : []

      const tab_color = ['#FF4848', '#2E9EFF', '#FFA93C']

      // console.log("Label ", tab_type);

      const valeurs = []
      const tab_sexe = ['Homme', 'Femme', 'Jeune']

      for (let j = 0; j < 3; j++) {
        const element = {}
        element.label = this.tranche_sexe[j]
        element.backgroundColor = tab_color[j]
        element.data = type_dom_data.length ? Object.values(type_dom_data[j]) : []

        valeurs.push(element)
      }

      const tableau = []
      tab_type.forEach(function (item) {
        item = item.substring(0, 18)
        tableau.push(item)
      })

      const type_data = {}
      type_data.labels = tableau
      type_data.datasets = valeurs
      // console.log("Valeurs Sexe",valeurs)

      this.type_sexe_chart_data = type_data
      this.loaded_type_sexe = true
      // }
    },

    loadChartTypeDomain() {
      // this.nb_check++;

      // if(this.nb_check >= 2){
      const tab_type = Object.keys(this.type_total)
      const tab_domaine = Object.keys(this.domaine_total)
      const type_dom_data = Object.values(this.matrix_dom_type)

      const tab_color = [
        '#FF4848',
        '#2E9EFF',
        '#FFA93C',
        '#78B943',
        '#4F5760',
        '#7B8BA0',
        '#6F0689',
        '#d500f9'
      ]

      // console.log("Label ", tab_type);

      const valeurs = []

      for (let i = 0; i < 8; i++) {
        const element = {}
        element.label = tab_domaine[i].substring(0, 35) + '...'
        element.backgroundColor = tab_color[i]
        element.data = Object.values(type_dom_data[i])

        valeurs.push(element)
      }

      const tableau = []
      tab_type.forEach(function (item) {
        item = item.substring(0, 18)
        tableau.push(item)
      })

      const type_data = {}
      type_data.labels = tableau
      type_data.datasets = valeurs
      // console.log("Valeurs ",valeurs)

      this.type_domaine_chart_data = type_data
      this.loaded_type_domaine = true
      // }
    },

    exportType() {
      const type_graphe = this.$refs.typedonutchart
      type_graphe.printDonutGraphe()
    },

    exportTypeSexe() {
      const type_graphe = this.$refs.typesexechart
      type_graphe.printBarGraphe()
    },

    exportTypeDomaine() {
      const type_graphe = this.$refs.typedomainechart
      type_graphe.printBarGraphe()
    }
  }
}
</script>

<style scoped>
.v-application a {
  cursor: pointer;
  text-decoration: none;
}

table,
td,
th {
  border: 1px solid #ddd;
  text-align: center;
}

table {
  border-collapse: collapse;
  width: 100%;
}

th,
td {
  padding: 10px;
}

th {
  background-color: #78b943;
  color: white;
}

/*tr:nth-child(even) {background-color: #f2f2f2;}*/
tr,
td {
  color: black;
  font-size: 1.1em;
}

.ligneTotal {
  background-color: #78b943;
  color: white;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/overview/statistic.vue